// NglMode.tsx
import React, { useCallback, useMemo, useState } from 'react';
import type { ModeId } from '../ModeLanding';
import ModeSelector from '../ModeSelector';
import NewDatabaseRowModal from '../NewDatabaseRowModal';
import SQLTable from '../../../components/sql_table/tableMain';
import { useApiData } from '../../../contexts/apiService';
import { useUserAccess, USER_ROLE_LEVEL } from '../../../contexts/userAccess';
import { getColConfigs } from '../tableConfig';

interface NglModeProps {
    initialMonth?: string;
    onChangeMode: (mode: ModeId) => void;
    onBackToOverview: () => void;
}

const NglMode: React.FC<NglModeProps> = ({ initialMonth, onChangeMode, onBackToOverview }) => {
    const { apiData } = useApiData();
    const { userRole = 'viewer', hasAdminAccess, hasAccAccess } = useUserAccess();
    const SCHEDULER = USER_ROLE_LEVEL['scheduler'];
    const showTable = Number(USER_ROLE_LEVEL[userRole]) >= SCHEDULER;

    const [selectedRowData, setSelectedRowData] = useState<any | null>(null);
    const [showRowModal, setShowRowModal] = useState(false);

    const handleRowClick = useCallback((rowData: any) => {
        setSelectedRowData(rowData);
    }, []);

    const handleCloseRowModal = useCallback(() => {
        setShowRowModal(false);
    }, []);

    const COL_CONFIGS = useMemo(() => getColConfigs('ngl_ticket_data', [], [], []), []);

    const tableData = apiData?.ngl_ticket_data || [];

    return (
        <>
            <div className="ticketData-topBar">
                <ModeSelector
                    activeMode="ngl"
                    onChangeMode={onChangeMode}
                    onBackToOverview={onBackToOverview}
                />
            </div>

            <div className="ticketData-contentContainer">
                <div className="ticketData-mainContent">
                    <div className="ticketData-tableContainer">
                        <div className="ticketData-tableWrapper">
                            <SQLTable
                                tableName="ngl_ticket_data"
                                tableData={tableData}
                                idColumn={'id'}
                                columnConfigs={COL_CONFIGS['ngl_ticket_data']?.columns ?? []}
                                sortOrder={COL_CONFIGS['ngl_ticket_data']?.sortOrder}
                                enableSummary={true}
                                summaryConfig={COL_CONFIGS['ngl_ticket_data']?.tableSummary}
                                monthNavigation={true}
                                initialMonthYear={initialMonth || undefined}
                                persistFilters={true}
                                showTable={showTable}
                                onRowClick={handleRowClick}
                                rowColor={COL_CONFIGS['ngl_ticket_data']?.rowColor}
                                userData={{ role: userRole, hasAccAccess, hasAdminAccess }}
                            />
                        </div>
                    </div>
                </div>

                <NewDatabaseRowModal
                    isOpen={showRowModal}
                    onClose={handleCloseRowModal}
                    rowData={selectedRowData}
                />
            </div>
        </>
    );
};

export default NglMode;
